import Vue from 'vue'
import Router from 'vue-router'
import Dash from '@/components/Dash/Dash'
import NotFoundView from '@/components/404.vue'
import Board from '@/components/Board/Board'
// import Client from '@/components/Client/Client'
import Clients from '@/components/Client/Clients'
// import EditClient from '@/components/Client/EditClient'
import Invoice from '@/components/Invoice/Invoice'
import Invoices from '@/components/Invoice/Invoices'
import Notifications from '@/components/Notifications/Notifications'
import Quote from '@/components/Quote/Quote'
import Quotes from '@/components/Quote/Quotes'
import Archive from '@/components/Archive/Archive'
import RepeatJobs from '@/components/RepeatJob/RepeatJobs'
// import CreateRepeatJob from '@/components/RepeatJob/CreateRepeatJob'
// import EditRepeatJob from '@/components/RepeatJob/EditRepeatJob'
// import Expenses from '@/components/Expenses/Expenses'
// import CreateExpense from '@/components/Expenses/CreateExpense'
// import EditExpense from '@/components/Expenses/EditExpense'
import Account from '@/components/Settings/Account'
import Payments from '@/components/Settings/Payments'
import ChaseEmails from '@/components/Settings/ChaseEmails'
import Bank from '@/components/Settings/Bank'
import Billing from '@/components/Settings/Billing'
import Support from '@/components/Support/Support'
import FAQs from '@/components/Support/Faqs'
import Business from '@/components/Settings/Business'
import SettingsView from '@/components/Settings/SettingsView'
import ForgotPassword from '@/components/User/ForgotPassword'
import CustomerInvoice from '@/components/Customer/CustomerInvoice'
import CustomerQuote from '@/components/Customer/CustomerQuote'
import InvoicePDF from '@/components/Customer/InvoicePDF'
import QuotePDF from '@/components/Customer/QuotePDF'
import SignIn from '@/components/User/SignIn'
import SignUp from '@/components/User/SignUp'
import Reactivate from '@/components/User/Reactivate'
import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/sign-in',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reactivate',
      name: 'Reactivate',
      component: Reactivate
    },
    {
      path: '/customerinvoice/:group_id/:invoice_id',
      name: 'CustomerInvoice',
      component: CustomerInvoice
    },
    {
      path: '/customerquote/:group_id/:quote_id',
      name: 'CustomerQuote',
      component: CustomerQuote
    },
    {
      path: '/invoicepdf/:group_id/:invoice_id',
      name: 'InvoicePDF',
      component: InvoicePDF
    },
    {
      path: '/quotepdf/:group_id/:quote_id',
      name: 'QuotePDF',
      component: QuotePDF
    },
    {
      path: '/',
      component: Dash,
      beforeEnter: AuthGuard,
      children: [
        {
          path: '',
          name: 'Board',
          component: Board
        },
        {
          path: '/clients',
          name: 'Clients',
          component: Clients
        },
        {
          path: '/invoices/show/:invoice_id',
          name: 'Invoice',
          component: Invoice
        },
        {
          path: '/invoices',
          name: 'Invoices',
          component: Invoices
        },
        {
          path: '/notifications',
          name: 'Notifications',
          component: Notifications
        },
        {
          path: '/quotes/show/:quote_id',
          name: 'Quote',
          component: Quote
        },
        {
          path: '/quotes',
          name: 'Quotes',
          component: Quotes
        },
        {
          path: '/archive',
          name: 'Archive',
          component: Archive
        },
        {
          path: '/repeat-jobs',
          name: 'RepeatJobs',
          component: RepeatJobs
        },
        {
          path: '/support',
          name: 'Support',
          component: Support
        },
        {
          path: '/support/faqs',
          name: 'FAQs',
          component: FAQs
        },
        {
          path: '/settings',
          component: SettingsView,
          children: [
            {
              path: '',
              name: 'Business',
              component: Business
            },
            {
              path: '/settings/account',
              name: 'Account',
              component: Account
            },
            {
              path: '/settings/payments',
              name: 'Payments',
              component: Payments
            },
            {
              path: '/settings/bank',
              name: 'Bank',
              component: Bank
            },
            {
              path: '/settings/chaseemails',
              name: 'ChaseEmails',
              component: ChaseEmails
            },
            {
              path: '/settings/billing',
              name: 'Billing',
              component: Billing
            }
          ]
        }
      ]
    }, {
      // not found handler
      path: '*',
      component: NotFoundView
    }
  ],
  mode: 'history',
  base: process.env.BASE_URL

})
